export const failedActionRegex = new RegExp(/_FAILED$/);

export const completedActionRegex = new RegExp(/_COMPLETED$/);

export const error4xxRegex = new RegExp(/^4[0-9].*$/);
